import { editTableTypes } from '../constants/edittableConstants';

const openWindow = (callback= ()=>{}, data) => ({
    type: editTableTypes.OPEN_CLOSE_WINDOW,
    opened: true,
    callback,
    data
});

const closeWindow = () => ({
    type: editTableTypes.OPEN_CLOSE_WINDOW,
    opened: false
});

const openChooseTemplateWindow = (callback= ()=>{}) => ({
    type: editTableTypes.OPEN_CLOSE_TEMPLATE_WINDOW,
    openedTemplate: true,
    callbackTemplate: callback
});

const closeChooseTemplateWindow = () => ({
    type: editTableTypes.OPEN_CLOSE_TEMPLATE_WINDOW,
    openedTemplate: false
});

const setData = (data) => ({
    type: editTableTypes.SET_FILES,
    data
});

export default {
    openWindow,
    closeWindow,
    setData,
    openChooseTemplateWindow,
    closeChooseTemplateWindow
};